// src/bootstrap/http/defaults.js

import axios from 'axios'
import Vue from 'vue'
import VueResource from 'vue-resource'

// Enable vue-resource once
Vue.use(VueResource)

// Axios defaults
axios.defaults.baseURL = '/'
axios.defaults.withCredentials = true

// vue-resource defaults
Vue.http.options.root = '/'
Vue.http.options.credentials = true
